import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=91ca57c2&scoped=true"
import script from "@/views/Users/Student/Notes.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Notes.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/notes.scss?vue&type=style&index=0&id=91ca57c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ca57c2",
  null
  
)

export default component.exports